import { AppState, Params, Thunk } from '@typings';
import * as services from '@services';
import { setPlatformAppsFetcher, setPlatformAppsLoader } from '@slices';
import { setPlatformAppsInstances } from '@slices/cache/platformApps/platformAppsInstances.slice';
import { setPlatformAppsTemplatesTags } from '@slices/cache/platformApps/platformAppsTemplatesTags.slice';

export const getPlatformAppsInstances =
  (
    context: Params.GetPlatformAppsInstances,
  ): Thunk<Promise<AppState.PlatformApps['instances']>> =>
  async (dispatch) => {
    try {
      const { items: instances } =
        await services.getPlatformAppsInstances(context);

      dispatch(setPlatformAppsInstances(instances));

      return instances;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getPlatformAppsTemplatesTags =
  (): Thunk<Promise<void>> => async (dispatch) => {
    try {
      dispatch(setPlatformAppsLoader({ templatesTags: true }));

      const tags = await services.getPlatformAppsTemplatesTags();

      dispatch(setPlatformAppsTemplatesTags(tags));
      dispatch(setPlatformAppsFetcher({ templatesTags: true }));
    } catch {
      /**
       * Continue regardless of the error
       */
    } finally {
      dispatch(setPlatformAppsLoader({ templatesTags: false }));
    }
  };
